export const tryParseJsonText = (text: string) => {
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
};
